module.exports = __webpack_public_path__ + "static/img/4.a9cb46f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v15_new_features/4.png
// module id = HYRN
// module chunks = 0